<template>
  <p>
    El radar perfilador de nubes es de tipo Doppler compacto y de bajo consumo.
    El instrumento opera a 9 mm de longitud de onda y es capaz de ofrecernos el
    espectro Doppler de las gotas de nubes ya calibrado. Debido a alta
    sensibilidad permite observar la estructura interna de la nube desde la
    superficie hasta 15 km dividido hasta en 1024 niveles de altura y resolución
    temporal típica de 10 segundos.
  </p>

  <img
    class="thumbnail instrument"
    src="@/assets/images/microfisica/instrumentos/radar-mira.webp"
    alt="Radar MIRA-35C"
  />

  <p>
    <b>
      Variables más importantes que registra:
    </b>
  </p>
  <List marked>
    <li>Reflectividad (dBZ)</li>
    <li>Velocidad Radial (m/s)</li>
    <li>Ancho Espectral (m/s)</li>
    <li>LDR (dB)</li>
  </List>

  <p>
    <b>Marca y modelo: </b> <br />
    METEK Meteorologische Messtechnik GmbH , Mira 35-C
  </p>

  <p>
    <b>País: </b> <br />
    Alemania.
  </p>

  <p>
    <b>Especificaciones técnicas: </b> <br />
    <a href="https://metek.de/product/mira-35c/" target="_blank"
      >https://metek.de/product/mira-35c/</a
    >
  </p>

  <p>
    <b>Responsable: </b> <br />
    cdelcastillo@igp.gob.pe
  </p>
</template>

<script>
import List from "@/components/ui/objects/List";
export default {
  components: { List },
};
</script>
